/**
 * @generated SignedSource<<60c13a810b1406f7419bf891488c9a9a>>
 * @relayHash ee2c6a18d841d37fb30880ac310078ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dbbbd84f1e38e47200ac4addeca6edb56946e326bc82cb145b26a2204085a797

import type { ConcreteRequest } from 'relay-runtime';
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type freeToStandardModalQuery$variables = {
  cloudId: string;
  isConfluence: boolean;
  isJira: boolean;
  isServiceCollectionFree?: boolean | null;
  jiraApplicationKey: JiraApplicationKey;
  projectType: JiraProjectType;
};
export type freeToStandardModalQuery$data = {
  readonly confluence_searchUser?: {
    readonly nodes: ReadonlyArray<{
      readonly confluencePerson: {
        readonly accountId: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly confluence_storage?: {
    readonly bytesLimit: AGG$Long | null;
    readonly bytesUsed: AGG$Long;
    readonly isUnlimited: boolean | null;
  } | null;
  readonly csm_storage?: {
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly jira?: {
    readonly allJiraProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly assignableUsers: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly accountId: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly jsm_storage?: {
    readonly allJiraProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly assignableUsers: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly accountId: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
};
export type freeToStandardModalQuery = {
  response: freeToStandardModalQuery$data;
  variables: freeToStandardModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConfluence"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJira"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isServiceCollectionFree"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraApplicationKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectType"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v8 = {
  "condition": "isConfluence",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v6/*: any*/),
        {
          "kind": "Literal",
          "name": "cql",
          "value": "type=user"
        },
        {
          "kind": "Literal",
          "name": "excludeServiceAppUsers",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "ConfluenceSearchConnection",
      "kind": "LinkedField",
      "name": "confluence_searchUser",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceSearchResponse",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "concreteType": "ConfluencePerson",
              "kind": "LinkedField",
              "name": "confluencePerson",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "displayName"
                },
                {
                  "concreteType": "Icon",
                  "kind": "LinkedField",
                  "name": "profilePicture",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "path"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "ConfluenceStorage",
      "kind": "LinkedField",
      "name": "confluence_storage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isUnlimited"
        },
        {
          "kind": "ScalarField",
          "name": "bytesUsed"
        },
        {
          "kind": "ScalarField",
          "name": "bytesLimit"
        }
      ]
    }
  ]
},
v9 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "jiraApplicationKey"
  },
  (v6/*: any*/)
],
v10 = {
  "args": (v9/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageAllowed"
},
v11 = {
  "args": (v9/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageUsed"
},
v12 = {
  "args": (v9/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageIsUnlimited"
},
v13 = [
  (v6/*: any*/),
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "types.0",
            "variableName": "projectType"
          }
        ],
        "kind": "ListValue",
        "name": "types"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "picture"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "args": (v13/*: any*/),
  "concreteType": "JiraProjectConnection",
  "kind": "LinkedField",
  "name": "allJiraProjects",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": (v14/*: any*/),
              "concreteType": "JiraAssignableUsersConnection",
              "kind": "LinkedField",
              "name": "assignableUsers",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraAssignableUsersEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v7/*: any*/),
                        (v15/*: any*/),
                        (v16/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "assignableUsers(first:10)"
            }
          ]
        }
      ]
    }
  ]
},
v18 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_SERVICE_DESK"
  },
  (v6/*: any*/)
],
v19 = {
  "args": (v18/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageAllowed"
},
v20 = {
  "args": (v18/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageUsed"
},
v21 = {
  "args": (v18/*: any*/),
  "kind": "ScalarField",
  "name": "attachmentStorageIsUnlimited"
},
v22 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_CUSTOMER_SERVICE"
  },
  (v6/*: any*/)
],
v23 = {
  "alias": "csm_storage",
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": (v22/*: any*/),
      "kind": "ScalarField",
      "name": "attachmentStorageAllowed"
    },
    {
      "args": (v22/*: any*/),
      "kind": "ScalarField",
      "name": "attachmentStorageUsed"
    },
    {
      "args": (v22/*: any*/),
      "kind": "ScalarField",
      "name": "attachmentStorageIsUnlimited"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "id"
},
v25 = {
  "args": (v13/*: any*/),
  "concreteType": "JiraProjectConnection",
  "kind": "LinkedField",
  "name": "allJiraProjects",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": (v14/*: any*/),
              "concreteType": "JiraAssignableUsersConnection",
              "kind": "LinkedField",
              "name": "assignableUsers",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraAssignableUsersEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        (v7/*: any*/),
                        (v15/*: any*/),
                        (v16/*: any*/),
                        (v24/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "assignableUsers(first:10)"
            },
            (v24/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "freeToStandardModalQuery",
    "selections": [
      (v8/*: any*/),
      {
        "condition": "isJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v17/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isServiceCollectionFree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "jsm_storage",
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v17/*: any*/)
            ]
          },
          (v23/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "freeToStandardModalQuery",
    "selections": [
      (v8/*: any*/),
      {
        "condition": "isJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v25/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isServiceCollectionFree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "jsm_storage",
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/)
            ]
          },
          (v23/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "dbbbd84f1e38e47200ac4addeca6edb56946e326bc82cb145b26a2204085a797",
    "metadata": {},
    "name": "freeToStandardModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "786e3468aaf86e6cd22477f3aba584d3";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
